import { render, staticRenderFns } from "./CellRendererPlotCategory.vue?vue&type=template&id=71b9c672&"
import script from "./CellRendererPlotCategory.vue?vue&type=script&lang=js&"
export * from "./CellRendererPlotCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports